import React from 'react';
import { connect } from 'react-redux';
import AlvarMapDesignPanel from './AlvarMapDesignPanel';
import PricePanel from './PricePanel';

const SidePanel = React.createClass({
  getInitialState() {
    return {
      isOptionsOpen: true,
    }
  },

  render() {
    const { globalState } = this.props;

    return (
      <div className="SidePanel">
        <AlvarMapDesignPanel
          className="SidePanel__upper"
          dispatch={this.props.dispatch}
          globalState={globalState}
          isOptionsOpen={this.state.isOptionsOpen}
          onOptionsClose={this._onOptionsClose}
        />
        <div className="SidePanel__lower">
          <PricePanel onOptionsClick={this._onOptionsClick} isOpen={this.state.isOptionsOpen} dispatch={this.props.dispatch} globalState={globalState} />
        </div>
      </div>
    );
  },

  _onOptionsClick() {
    this.setState({
      isOptionsOpen: !this.state.isOptionsOpen,
    });
  },
  _onOptionsClose() {
    this.setState({
      isOptionsOpen: false,
    });
  }
});

export default connect(state => ({ globalState: state }))(SidePanel);



// WEBPACK FOOTER //
// ./src/components/SidePanel.js